// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.remote-control-played {
    background: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.remote-control-played h2 {
    font-size: 1.5rem;
    color: #333;
    margin: 0 0 20px 0;
    font-weight: 600;
}

.country-section {
    margin-bottom: 10px;
}

.country-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    background-color: #e3f2fd;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.country-header:hover {
    background-color: #bbdefb;
}

.country-header.expanded {
    background-color: #2196f3;
    color: white;
}

.expand-icon {
    font-size: 12px;
    transition: transform 0.3s ease;
}

.country-content {
    border: 1px solid #e0e0e0;
    border-top: none;
    padding: 20px;
    background-color: #fafafa;
}

.cars-grid {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 30px;
}

.cars-chart h3,
.cars-summary h3 {
    font-size: 1.2rem;
    color: #333;
    margin: 0 0 15px 0;
    font-weight: 600;
}

.chart-title {
    font-size: 14px;
    color: #666;
    margin-bottom: 15px;
}

.chart-container {
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.summary-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.summary-table th,
.summary-table td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
}

.summary-table th {
    background-color: #f8f9fa;
    font-weight: 600;
    color: #333;
}

.summary-table .total-row {
    background-color: #e3f2fd;
    font-weight: 500;
}

.custom-tooltip {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 10px;
    font-size: 12px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.tooltip-label {
    font-weight: 600;
    margin-bottom: 5px;
    color: #333;
}

@media (max-width: 1024px) {
    .cars-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }
}

@media (max-width: 768px) {
    .remote-control-played {
        padding: 15px;
    }

    .country-header {
        padding: 12px 15px;
    }

    .country-content {
        padding: 15px;
    }

    .chart-container {
        height: 250px;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/RemoteControlPlayed.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;;IAEI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".remote-control-played {\r\n    background: white;\r\n    border-radius: 8px;\r\n    padding: 20px;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n.remote-control-played h2 {\r\n    font-size: 1.5rem;\r\n    color: #333;\r\n    margin: 0 0 20px 0;\r\n    font-weight: 600;\r\n}\r\n\r\n.country-section {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.country-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 15px 20px;\r\n    background-color: #e3f2fd;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n}\r\n\r\n.country-header:hover {\r\n    background-color: #bbdefb;\r\n}\r\n\r\n.country-header.expanded {\r\n    background-color: #2196f3;\r\n    color: white;\r\n}\r\n\r\n.expand-icon {\r\n    font-size: 12px;\r\n    transition: transform 0.3s ease;\r\n}\r\n\r\n.country-content {\r\n    border: 1px solid #e0e0e0;\r\n    border-top: none;\r\n    padding: 20px;\r\n    background-color: #fafafa;\r\n}\r\n\r\n.cars-grid {\r\n    display: grid;\r\n    grid-template-columns: 2fr 1fr;\r\n    gap: 30px;\r\n}\r\n\r\n.cars-chart h3,\r\n.cars-summary h3 {\r\n    font-size: 1.2rem;\r\n    color: #333;\r\n    margin: 0 0 15px 0;\r\n    font-weight: 600;\r\n}\r\n\r\n.chart-title {\r\n    font-size: 14px;\r\n    color: #666;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.chart-container {\r\n    height: 300px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.summary-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    font-size: 14px;\r\n}\r\n\r\n.summary-table th,\r\n.summary-table td {\r\n    padding: 10px;\r\n    text-align: left;\r\n    border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.summary-table th {\r\n    background-color: #f8f9fa;\r\n    font-weight: 600;\r\n    color: #333;\r\n}\r\n\r\n.summary-table .total-row {\r\n    background-color: #e3f2fd;\r\n    font-weight: 500;\r\n}\r\n\r\n.custom-tooltip {\r\n    background: white;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 4px;\r\n    padding: 10px;\r\n    font-size: 12px;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n.tooltip-label {\r\n    font-weight: 600;\r\n    margin-bottom: 5px;\r\n    color: #333;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n    .cars-grid {\r\n        grid-template-columns: 1fr;\r\n        gap: 20px;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .remote-control-played {\r\n        padding: 15px;\r\n    }\r\n\r\n    .country-header {\r\n        padding: 12px 15px;\r\n    }\r\n\r\n    .country-content {\r\n        padding: 15px;\r\n    }\r\n\r\n    .chart-container {\r\n        height: 250px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
